import { memo, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Stack, Title, SimpleGrid, Anchor } from 'components'
import { useTranslation } from 'react-i18next'
import { IconSparkles, IconPencil, IconChevronLeft } from '@tabler/icons-react'
import { SelectionCard } from '../components/SelectionCard'

type FlowType = 'ai' | 'manual'

interface SelectionViewProps {
  onSelect: (type: FlowType) => void
}

export const SelectionView = memo<SelectionViewProps>(({ onSelect }) => {
  const { t } = useTranslation()

  const handleAI = useCallback(() => onSelect('ai'), [onSelect])
  const handleManual = useCallback(() => onSelect('manual'), [onSelect])

  return (
    <Stack spacing="xl">
      <Stack spacing={0} align="flex-start">
        <Anchor
          component={Link}
          to="/projects"
          sx={{ display: 'flex', alignItems: 'center', gap: 4 }}
        >
          <IconChevronLeft size={16} />
          {t('arc_back_to_projects')}
        </Anchor>
        <Title order={1}>{t('new_project_title')}</Title>
      </Stack>

      <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]} spacing="lg">
        <SelectionCard
          title={t('arc_selection_ai_title')}
          description={t('arc_selection_ai_description')}
          buttonText={t('arc_create_with_ai')}
          buttonIcon={<IconSparkles size={18} />}
          onClick={handleAI}
        />
        <SelectionCard
          title={t('arc_selection_manual_title')}
          description={t('arc_selection_manual_description')}
          buttonText={t('arc_create_manual')}
          buttonIcon={<IconPencil size={18} />}
          onClick={handleManual}
        />
      </SimpleGrid>
    </Stack>
  )
})

SelectionView.displayName = 'SelectionView'
